import { GetRewardsQuery, GetEmployeeRewardsQuery, RewardReason } from "generated/graphql";

export type DPReward = GetRewardsQuery["employer"]["currentProvider"]["rewards"]["items"][0];
export type DPEmployeeeReward = GetEmployeeRewardsQuery["employeeProfile"]["employee"]["rewards"]["items"][0];

export enum RewardStatus {
  pendingApproval = "pending_approval",
  approved = "approved",
  rejected = "rejected",
  paid = "paid",
  withheld = "withheld",
  unprocessed = "unprocessed"
}

export const rewardStatusDictionary: {
  [value in RewardStatus]: string
} = {
  [RewardStatus.approved]: "Approved",
  [RewardStatus.rejected]: "Rejected",
  [RewardStatus.pendingApproval]: "Pending Approval",
  [RewardStatus.paid]: "Paid",
  [RewardStatus.withheld]: "Failed",
  [RewardStatus.unprocessed]: "Processing"
};

export const rewardReasonDictionary: {
  [value in RewardReason]: string
} = {
  [RewardReason.GreatPerformance]: "Great Performance",
  [RewardReason.ShiftCoverage]: "Shift Coverage",
  [RewardReason.WorkAnniversary]: "Work Anniversary",
  [RewardReason.Birthday]: "Birthday",
  [RewardReason.Other]: "Other",
};
